import React, { Component } from 'react';
import { Panel, PanelHeader } from '@vkontakte/vkui';
import { push, goBack } from 'react-router-redux';
import BackButton from "../components/BackButton";
import {popHistory, pushHistory, swipeOn} from "../store/globals/actions";

export default class DefaultPanel extends Component {

    constructor(props) {
        super(props);

        // Настройки по-умолчанию
        this.title = 'Панель';
        this.theme = 'white';
        this.hasBack = false;
        this.hasSwipe = false;
        this.customLeft = undefined;

        this.pConstructor();
    }

    openPage(page) {
        this.props.dispatch(push('/' + page));
    }

    openBack() {
        this.props.dispatch(goBack());
        this.customBack();
    }

    componentDidMount() {
        if (this.hasSwipe) {
            this.props.dispatch(pushHistory(this.props.id));
            this.props.dispatch(swipeOn());
        }
        this.pComponentDidMount();
    }

    componentWillMount() {
        this.pComponentWillMount();
    }

    customBack = () => {
        if (this.hasSwipe) this.props.dispatch(popHistory());
    };

    renderPanel() {}

    settings() {}

    pConstructor() {}

    pComponentDidMount() {}

    pComponentWillMount() {}

    render() {
        this.settings();

        return (
            <Panel id={ this.props.id } theme={ this.theme } >
                <PanelHeader
                    left={[
                        this.hasBack && <BackButton key={ 'bk_btn' } customBack={ this.customBack }/>,
                        (!this.hasBack && this.customLeft !== undefined) && this.customLeft,
                    ]}
                >
                    { this.title }
                </PanelHeader>
                { this.renderPanel() }
            </Panel>
        );
    }

}


// WEBPACK FOOTER //
// ./src/js/classes/DefaultPanel.js